import React from 'react'
import IosShareOutlined from '@mui/icons-material/IosShareOutlined'
import ArrowBack from '@mui/icons-material/ArrowBack'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import { FormSpacer } from 'ui/styled'
import { BaseSkeleton } from 'components/Skeleton'
import CatalogState from 'components/CatalogState'
import Button from 'components/Form/Button'
import VideoList from 'components/VideoList'
import VideoCard from 'components/Cards/VideoCard'
import SearchHighlight from 'components/SearchHighlight'
import SearchResultCard from 'components/SearchResultCard'
import CustomTablePagination from 'components/CustomTablePagination'
import useController from './controller'
import { SearchRoot, SearchTitle, Tabs, Tab, Summary, Results, RelatedTitle, Paging, Toolbar, Notice, TabCount, SecondaryAction } from './styled'

export default function SubCategoryFiltred() {
  const { t, q, type, data, loading, error, tabs, sharing, setSharing, canShare, retry, onTypeChange, onPageChange, showRelated, onOpen } = useController()
  return (
    <>
    <FormSpacer extraLarge />
    <SearchRoot aria-busy={loading}>
      <SearchTitle>{t('search')} {q ? `“${q}”` : ''}</SearchTitle>
      <Tabs aria-label={t('search.filters')}>
        {tabs.map(key => <Tab type="button" key={key} $active={type === key} aria-current={type === key ? 'page' : undefined} onClick={() => onTypeChange(key)}>{t(`search.types.${key}`)}{data?.facets?.[key] ? <> <TabCount>({data.facets[key]})</TabCount></> : null}</Tab>)}
      </Tabs>
      {loading ? <div role="status" aria-label={t('search.loading')}><BaseSkeleton height={90} count={4} /></div> : error ? (
        <CatalogState title={t('search.error')} description={t('search.errorHelp')} actionLabel={t('try_again')} onAction={retry} />
      ) : q.length < 2 ? <CatalogState title={t('search.start')} /> : (
        <>
          {data?.semanticUnavailable ? <Notice role="status"><InfoOutlined aria-hidden="true" />{t('search.degraded')}</Notice> : null}
          {data?.candidateLimitReached ? <Summary>{t('search.refine')}</Summary> : null}
          <Toolbar>
            {data?.total ? <Summary role="status"><strong>{data.total}</strong> {t(data.total === 1 ? 'search.result' : 'search.results')}</Summary> : null}
            {!canShare || !data?.results?.length ? null : <Button nospace color="blue" width="auto" startIcon={sharing ? <ArrowBack /> : <IosShareOutlined />} onClick={() => setSharing(value => !value)}>{t(sharing ? 'search.backToResults' : 'search.shareResources')}</Button>}
          </Toolbar>
          {data?.total ? null : <CatalogState title={`${t('search.noResults')} “${q}”`} description={t('search.emptyHelp')} />}
          {data?.total && !data.directCount ? <Summary>{t('search.noDirect')}</Summary> : null}
          {sharing ? <VideoList initiallySharing data={{ title: t('search.shareResources'), data: data?.results || [] }} renderOption="gallery" wide nobutton /> : <Results $images={type === 'images'} $documents={type === 'documents'}>
            {(data?.results || []).map((item, index) => <React.Fragment key={item.resourceKey}>
              {item.match === 'related' && (index === 0 || data.results[index - 1].match !== 'related') ? <RelatedTitle>{t('search.related')}</RelatedTitle> : null}
              {type === 'documents' || type === 'images' ? <VideoCard
                video={{
                  ...item,
                  image: item.image?.url ? item.image : item.kind === 'images' && item.document ? { url: item.document } : null,
                  category: t(`search.types.${item.kind}`),
                  document_type: item.mime === 'application/pdf' ? 'PDF' : item.document_type,
                }}
                wide
                fullWidth
                fallbackLabel={item.mime === 'application/pdf' ? 'PDF' : t(`search.types.${item.kind}`)}
                titleContent={<SearchHighlight text={item.title} query={q} />}
                handleDownload={() => onOpen(item, index)}
              /> : <SearchResultCard item={item} query={q} visual={type === 'images'} label={t(`search.types.${item.kind}`)} onOpen={() => onOpen(item, index)} />}
            </React.Fragment>)}
          </Results>}
          {!data?.relatedHidden || !data?.relatedCount ? null : <SecondaryAction type="button" onClick={showRelated}>{t('search.showRelated')} ({data.relatedCount})</SecondaryAction>}
          {data?.total > data?.pageSize ? <Paging><CustomTablePagination count={data.total} page={data.page - 1} rowsPerPage={data.pageSize} onPageChange={onPageChange} /></Paging> : null}
        </>
      )}
    </SearchRoot>
    </>
  )
}
